/* eslint angular/log: 0 */
/** Cannot use angular's log in ServiceProvider, because it gets
 * intialised BEFORE the Service gets initialised.' */

/**
 * @typedef {Object} AppProvider
 *
 * @property {function} setContentMode
 * @property {function} setContentModeFromSubdomain
 * @property {function} setDevelopmentMode
 * @property {function} isDevelopmentMode
 */


/**
 * @typedef {Object} App
 *
 * @property {function} setContentMode
 * @property {function} isPublicMode
 * @property {function} isStageMode
 * @property {function} getContentMode
 */


(function() {
    'use strict';

    angular.module( APP_ID )
        .provider( 'App', AppProvider );

   /**
    * Providing application's general settings and configurations.
    *
    * Note: `CONFIG` contains immutable settings and defaults that **MUST NOT**
    * be changed on runtime (under standard non-development circumstances),
    * whereas AppProvider **SHOULD** hold all global (and adjustable) settings.
    */
    function AppProvider( CONFIG ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {AppProvider} */
        var AppProvider = this;


        /** @constant */
        var ID = '[AppProvider]';


        /** @type {App} */
        function App() {
            var publicAPI = {
                setContentMode:     setContentMode,
                isPublicMode:       isPublicMode,
                isStageMode:        isStageMode,
                getContentMode:     function() { return contentMode; }
            };

            return publicAPI;
        };
        this.$get = App;





        /* ===== EXPOSE TO THE PROVIDER ===================================== */



        // Hint: Use following methods to set up the App BEFORE angular.run() is called!
        AppProvider.setContentMode              = setContentMode;
        AppProvider.setContentModeFromSubdomain = setContentModeFromSubdomain;
        AppProvider.setDevelopmentMode          = setDevelopmentMode;
        AppProvider.isDevelopmentMode           = function() { return developmentMode };





        /* ===== PRIVATE MEMBERS ============================================ */


        /**
         * Mode with its configuration parameters (see MODES in app.config.js).
         *
         * @type {Object}
        */
        var contentMode    = CONFIG.MODES.PUBLIC;


        /**
         * By setting 'development mode', one can influence the logging to the
         * console and other helpful services.
         *
         * @type {boolean}
         */
        var developmentMode = CONFIG.IS_DEVELOPMENT_MODE;





        /* ===== PUBLIC FUNCTIONS =========================================== */


        /** @param {string} contentModeKey */
        function setContentMode( contentModeKey ) {
            // NOTE: ModeId needs to match with the Object attribute name
            var contentModeObject = CONFIG.MODES[ contentModeKey.toUpperCase() ];

            if ( angular.isDefined( contentModeObject ) ) {
                contentMode = contentModeObject;
            } else {
                if ( developmentMode ) console.error( ID, "Mode called `" +  contentModeKey + "` probably does not exist. Please, make sure that your Mode key matches any of the objects under MODES inside config/app.config.js file.");
            }
        }


        /** @param {string} subdomain */
        function setContentModeFromSubdomain( subdomain ){
            var newContentMode = CONFIG.MODES.PUBLIC;

            // Match current subdomain with Configuration
            Object.keys( CONFIG.MODES ).forEach( function( key ) {
                if ( subdomain === CONFIG.MODES[ key ].SUBDOMAIN) {
                    newContentMode = CONFIG.MODES[ key ];
                    if ( developmentMode ) console.log( ID, "'" + newContentMode.MODE_ID + "' content mode is available!" );
                }
            });

            contentMode = newContentMode;
        }


        /** @param {boolean} isDevelopmentModeOn */
        function setDevelopmentMode( isDevelopmentModeOn ) {
            developmentMode = isDevelopmentModeOn;
            console.log( ID, "Development mode turned manually " + ( developmentMode ? "ON" : "OFF" ) + "!" );
        }


        /** @returns {boolean}  */
        function isPublicMode() {
            return ( contentMode.MODE_ID === CONFIG.MODES.PUBLIC.MODE_ID );
        }


        /** @returns {boolean}  */
        function isStageMode() {
            return ( contentMode.MODE_ID === CONFIG.MODES.STAGE.MODE_ID );
        }


    }



    AppProvider.$inject = [ 'CONFIG' ];
})();
